'use client'
import React from 'react'

import { useGladlyHelpCenter } from '@src/hooks/useGladlyHelpCenter'
import { getIsNativeViewClient } from '@src/quince-site-common/src/helpers/getIsNativeViewClient'

import styles from './glady-help-center.module.scss'

const css = `#gladlyChatTempWrapper,
#gladlyChatDragHandle {
  padding: 1.8rem 2rem !important;
}`

const GladlyHelpCenter = () => {
  useGladlyHelpCenter()
  const quinceMobileApp = getIsNativeViewClient()

  return (
    <>
      {quinceMobileApp && <style>{css}</style>}
      <div id="gladly-help-center" className={styles.gladlyHelpCenter}></div>
    </>
  )
}

export default GladlyHelpCenter
